import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function BeforeArriving() {
  return (
    <>
      {/* Hero Section */}
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/carousel/opdmain.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown" style={{ fontFamily: 'Georgia, serif' }}>
            Before Arriving
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Before Arriving
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px' }}>
        {/* Introductory Section */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Planning ahead can help reduce delays and make your visit to Tema General Hospital smoother and less stressful.
            </p>
          </div>
        </ScrollSection>

        {/* Section 1: Check Your Insurance Status */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Check Your Insurance Status
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Before coming to the hospital, ensure that your <strong>insurance is active and valid</strong>.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              What to Do
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: '2rem' }}>
              <li>Confirm your <strong>NHIS card is active and not expired</strong></li>
              <li>If using private insurance, confirm:
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>The insurance is accepted at TGH</li>
                  <li>Your coverage is still valid</li>
                  <li>Whether pre-authorization is required</li>
                </ul>
              </li>
            </ul>

            <div className="p-4" style={{ backgroundColor: 'var(--tgh-surface-tint)', borderRadius: '8px', borderLeft: '4px solid var(--tgh-blue-light)' }}>
              <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                <strong>Note:</strong> Insurance is checked at the <strong>Records Unit</strong> before you can be registered and booked to see a doctor.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 2: Bring the Right Documents */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Bring the Right Documents
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
              Make sure you come with:
            </p>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Your <strong>NHIS or private insurance card</strong></li>
              <li>Any <strong>hospital card or folder</strong> (for returning patients)</li>
              <li>Valid identification (if available)</li>
              <li>Referral notes or medical reports (if referred from another facility)</li>
            </ul>
          </div>
        </ScrollSection>

        {/* Section 3: Prepare for Possible Payments */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Prepare for Possible Payments
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Even with insurance, some services may not be covered.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Things to Consider
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Some medications, tests, or procedures may require <strong>out-of-pocket payment</strong></li>
              <li>Payments are made at the <strong>hospital bank teller</strong></li>
              <li>It is advisable to come prepared for possible additional costs</li>
            </ul>
          </div>
        </ScrollSection>

        {/* Section 4: Plan Your Time */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Plan Your Time
            </h2>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: '1rem' }}>
              <li>Arrive <strong>early</strong>, especially for OPD services</li>
              <li>Allow extra time for:
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>Registration</li>
                  <li>Insurance verification</li>
                  <li>Billing and payments</li>
                </ul>
              </li>
              <li>Morning hours are often busy</li>
            </ul>
          </div>
        </ScrollSection>

        {/* Section 5: Know Where to Go First */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Know Where to Go First
            </h2>
            <div className="row g-4">
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <div className="mb-3" style={{ fontSize: '2.5rem', color: 'var(--tgh-blue-light)' }}>
                    <i className="bi bi-clipboard-check"></i>
                  </div>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Regular Patients
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    All patients should report to the <strong>Records / OPD Registration Desk</strong> on arrival.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <div className="mb-3" style={{ fontSize: '2.5rem', color: 'var(--tgh-blue-light)' }}>
                    <i className="bi bi-heart-pulse"></i>
                  </div>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Emergency Patients
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Emergency patients should proceed directly to the <strong>Emergency Unit</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollSection>

        {/* Section 6: Personal & Health Preparation */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Personal & Health Preparation
            </h2>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Carry any <strong>current medications</strong> you are taking</li>
              <li>Be ready to provide accurate health information</li>
              <li>Wear comfortable clothing</li>
              <li>Bring only essential personal items</li>
            </ul>
          </div>
        </ScrollSection>

        {/* Section 7: For Inpatient (IPD) Visits */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              For Inpatient (IPD) Visits
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
              If admission is planned:
            </p>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Inform a relative or caregiver</li>
              <li>Prepare basic personal items</li>
              <li>Be aware that bills accumulate during admission</li>
              <li>Know that <strong>Social Services support is available</strong> for IPD patients facing financial difficulty</li>
            </ul>
          </div>
        </ScrollSection>

        {/* Helpful Tip */}
        <ScrollSection>
          <div>
            <div className="p-4" style={{ backgroundColor: 'var(--tgh-surface-tint)', borderRadius: '8px', borderLeft: '4px solid var(--tgh-blue-light)' }}>
              <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                <strong>Helpful Tip:</strong> Ensuring your insurance is active before arrival helps the Records Unit register you faster and reduces delays in seeing a doctor.
              </p>
            </div>
          </div>
        </ScrollSection>
      </div>
    </>
  );
}

export default BeforeArriving;
